/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preview_ResourcesInputs */

const zh_preview_resources = /** @type {(inputs: Preview_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`资源`)
};

const en_preview_resources = /** @type {(inputs: Preview_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resources`)
};

const es_preview_resources = /** @type {(inputs: Preview_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recursos`)
};

/**
* | output |
* | --- |
* | "Resources" |
*
* @param {Preview_ResourcesInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const preview_resources = /** @type {((inputs?: Preview_ResourcesInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preview_ResourcesInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_preview_resources(inputs)
	if (locale === "en") return en_preview_resources(inputs)
	return es_preview_resources(inputs)
});